module.exports = __webpack_public_path__ + "media/images/gallery/constellations/variables_layer_off-32541ecc2ef8a9acaf0a728b27b0acb4.jpg";